import { useState, useEffect } from 'react';
import StatusBadge from '../../../StatusBadge.jsx';
import { getConnectionModelSummary } from '../../../../libs/fetch.js';
import DataSourceCard from './DataSourceCard.jsx';
import DataSourceSkeleton from './DataSourceSkeleton.jsx';

export default function IntegrationStatus(props) {
  const {
    status,
    connection_id,
    name,
  } = props;

  const [dataSources, setDataSources] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!connection_id) return;

    const fetchDataSources = async () => {
      setLoading(true);
      try {
        const data = await getConnectionModelSummary(connection_id);
        setDataSources(data);
      } catch (error) {
        console.error("Error fetching data sources:", error);
        setDataSources([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDataSources();
  }, [connection_id]);

  return (
    <div className="px-4 sm:px-0">
      <h3 className="mt-5 text-base font-semibold leading-7 text-gray-900">
        {name} Status
      </h3>

      <div className="mt-3 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          {/* Status Row */}
          <div className="flex items-center gap-2 px-4 py-3">
            <dt className="text-sm font-medium text-gray-900">Status:</dt>
            <dd className="text-sm text-gray-700">
              <StatusBadge status={status} />
            </dd>
          </div>

          {/* Data Sources */}
          <div className="px-4 py-6 sm:px-0">
            <h4 className="text-sm font-medium text-gray-900 mb-2">Data Sources</h4>
            <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
              {loading
                ? Array.from({ length: 3 }).map((_, idx) => <DataSourceSkeleton key={idx} />)
                : dataSources?.length > 0
                  ? dataSources.map((source) => (
                      <DataSourceCard key={source.external_model_id} source={source} />
                    ))
                  : <p className="text-sm text-gray-500">No data sources available.</p>
              }
            </div>
          </div>
        </dl>
      </div>
    </div>
  );
}
